import { styled } from '@mui/material/styles';

export const RoomAssignmentsContainer = styled('div')({
  maxWidth: 1100,
  width: '100%',
  margin: '0 auto',
});

/** Separates one checklist from the next (matches realm Doc category spacing). */
export const ChecklistRoot = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));

/** Checkpoint rows: negative margin + padding preserves layout vs. former titleBlock -20px while zebra fills full width. */
export const CheckpointListRow = styled('div')(({ theme }) => ({
  marginLeft: -20,
  paddingLeft: 20,
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  boxSizing: 'border-box',
}));

/** Alternating row banding on even children for scanability (theme-aware, matches users/manage). */
export const ZebraList = styled('div')(({ theme }) => ({
  '& > *:nth-child(even)': {
    backgroundColor: theme.palette.action.disabledBackground,
  },
}));

/** Inset (marginLeft) + zebra banding wrapper — combines the former styles.marginLeft + styles.zebraList. */
export const MarginLeftZebraList = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(3),
  '& > *:nth-child(even)': {
    backgroundColor: theme.palette.action.disabledBackground,
  },
}));
